import styled from 'styled-components'

export const FormFooter = styled.div`
    position: sticky;
    bottom: -1.25rem;
    z-index: 2;
    display: flex;
    justify-content: flex-start;
    padding: 0.75rem 0;
    margin-top: 0.5rem;
    border-top: 1px solid ${({ theme }) => theme.colors.line};
    background: ${({ theme }) => theme.colors.surface};

    button {
        min-width: 8rem;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        bottom: -1rem;
        button {
            width: 100%;
        }
    }
`

export default FormFooter
